import { Component, inject, output } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { IconButtonComponent, IconComponent } from '@core/user-interface-legacy';

import { HrAssistantChatFeatureService } from '../hr-assistant-chat-feature.service';

@Component({
  selector: 'tlc-chat-header-thread',
  imports: [TranslatePipe, IconButtonComponent, IconComponent],
  template: `
    <rt-icon-button
      iconName="arrow-back"
      size="small"
      variant="plain"
      (click)="back.emit($event)"
    />
    <span layout layout-align-items-center text-semi-medium>
      {{ 'tlc.hr_assistant.your_thread' | translate }}
      <rt-icon-button
        margin-left-small-x
        iconName="edit-square"
        variant="plain"
        size="small"
        (click)="newThread()"
      />
    </span>
    <rt-icon-button iconName="close" size="small" variant="plain" (click)="close.emit($event)" />
  `,
  styleUrls: ['./header-thread.component.less'],
})
export class HeaderThreadComponent {
  private readonly hrAssistantFeaturesService = inject(HrAssistantChatFeatureService);

  public close = output<MouseEvent>();
  public back = output<MouseEvent>();

  protected newThread() {
    this.hrAssistantFeaturesService.newThread$.next();
  }
}
